import { atom, selector } from 'recoil'

export const modalCopyState = atom({
  key: 'templateListModalCopyState',
  default: {
    show: false,
    id: undefined,
    title: '',
    lists: [],
    copyToLists: [],
    selectAll: false
  }
})

export const modalCopyValidState = selector({
  key: 'templateListModalCopyValidState',
  get: ({ get }) => {
    const { title, selectAll, lists, copyToLists } = get(modalCopyState)

    return (
      title.trim().length > 0 &&
      (selectAll ? lists.length > 0 : copyToLists.length > 0)
    )
  }
})

export const modalDeleteState = atom({
  key: 'templateListModalDeleteState',
  default: {
    show: false,
    id: undefined
  }
})

export const modalOfferLightUpsellState = atom({
  key: 'templateList__modalOfferLightUpsell',
  default: {
    show: false
  }
})
